import React from "react";

/**
 * Divider — Horizontal rule with centered "or" text.
 */
export default function Divider() {
  return (
    <div style={styles.wrap}>
      <div style={styles.line} />
      <span style={styles.text}>or</span>
      <div style={styles.line} />
    </div>
  );
}

const styles = {
  wrap: {
    display: "flex",
    alignItems: "center",
    margin: "20px 0",
  },
  line: {
    flex: 1,
    height: 1,
    backgroundColor: "#e5e7eb",
  },
  text: {
    padding: "0 12px",
    fontSize: 12,
    color: "#9ca3af",
    fontFamily: "'Inter', sans-serif",
  },
};
